import { useMemo } from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';

import {
  setPage,
  setLimit,
  setTotal,
  setColumnVisibility,
  setRoundTransactionsTableFilters,
  setClearRoundTransactionsTableFilters,
} from '@Modal/reducers/transaction/table/transactionTableSlice';

// Types
import { StoreInterface } from 'src/app/types';
import { FilterItemType } from '@Modal/reducers/types';

export const useTransactionTable = () => {
  const dispatch = useDispatch();

  const {
    columnVisibility,
    columnVisibilityOptions,
    selectedFilters,
    limit,
    page,
    total,
    roundTransactionsTableFilters,
  } = useSelector((state: StoreInterface) => state?.transactionTable);

  const transactionListFilters = useMemo(() => {
    const columnVisibilityStrArr = Array.from(Object.values(columnVisibility)).map((filt) => filt);
    return columnVisibilityStrArr as string[];
  }, [columnVisibility]);

  const handleApplyColumnVisibility = (column: string[]) => {
    const newVisibleColumns = [...transactionListFilters, ...column];
    if (transactionListFilters.filter((col) => column.includes(col)).length > 0) {
      const filteredNewVisibleColumns = transactionListFilters.filter((col) => col !== column[0]);
      dispatch(setColumnVisibility(filteredNewVisibleColumns));
    } else {
      dispatch(setColumnVisibility(newVisibleColumns));
    }
  };

  const visiblityCustomizable = useMemo(
    () => ({
      value: columnVisibility,
      options: columnVisibilityOptions,
      apply: (value: string[]) => handleApplyColumnVisibility(value),
    }),
    [columnVisibility, columnVisibilityOptions]
  );

  const handleFilterSelect = (filter: FilterItemType) => {
    dispatch(setRoundTransactionsTableFilters(filter));
  };

  const handleClearRoundTransactionsTableFilters = () => {
    dispatch(setClearRoundTransactionsTableFilters());
  };

  return {
    // State
    page,
    total,
    limit,
    selectedFilters,
    columnVisibility,
    visiblityCustomizable,
    transactionListFilters,
    columnVisibilityOptions,
    roundTransactionsTableFilters,
    // Actions
    setPage,
    setTotal,
    setLimit,
    setRoundTransactionsTableFilters,
    setClearRoundTransactionsTableFilters,
    // Handlers
    handleFilterSelect,
    handleApplyColumnVisibility,
    handleClearRoundTransactionsTableFilters,
  };
};
